<template>
  <div class="roboto-regular">
    <NavBar />
    <div class="dark:bg-gray-900 dark:text-gray-200 py-12 mx-auto px-4">
      <HomePage />
    </div>
  </div>
</template>

<script>
import NavBar from "@/components/NavBar.vue";
import HomePage from "@/views/HomePage.vue";
export default {
  name: 'App',
  components: {
    HomePage,
    NavBar
  }
};
</script>
